// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"Tournaments_scrollContainer__s4owD","error":"Tournaments_error__uSgMq"};